import { NavItemModel } from '../../common';

export const NAVBAR_ASSORTMENT_ROUTE_NAME: string = 'assortment';
export const NAVBAR_ASSORTMENT_ROUTE: string = 'assortment-nav';
export const navbarAssortmentNavItem: NavItemModel = {
  name: NAVBAR_ASSORTMENT_ROUTE_NAME,
  label: 'Sortiment',
  url: NAVBAR_ASSORTMENT_ROUTE,
  icon: {
    name: 'bars-staggered',
    family: 'light',
  },
};

export const NAVBAR_OFFERS_ROUTE_NAME: string = 'offers';
export const navbarOffersNavItem: NavItemModel = {
  name: NAVBAR_OFFERS_ROUTE_NAME,
  url: NAVBAR_OFFERS_ROUTE_NAME,
  label: 'Angebote',
  icon: {
    name: 'percent',
    family: 'light',
  },
};

export const NAVBAR_ORDER_MANAGER_ROUTE_NAME: string = 'order-manager';
export const navbarOrderManagerNavItem: NavItemModel = {
  name: NAVBAR_ORDER_MANAGER_ROUTE_NAME,
  label: 'Bestellmanager',
  url: NAVBAR_ORDER_MANAGER_ROUTE_NAME,
  icon: {
    name: 'clipboard-list-check',
    family: 'light',
  },
};

export const navbarNavigationItemsBase: NavItemModel[] = [
  navbarAssortmentNavItem,
  navbarOffersNavItem,
  navbarOrderManagerNavItem,
];

export const navbarOverlayRoutes: string[] = [NAVBAR_ASSORTMENT_ROUTE, NAVBAR_OFFERS_ROUTE_NAME, NAVBAR_ORDER_MANAGER_ROUTE_NAME];
